var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCalendarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Rides",
    transform: "translate(-22.000000, -470.000000)",
    stroke: "#191919",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_calendar-copy-ico_calendar",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 19 18 19 18 4 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0003,9.0001 L17.9997,9.0001",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9997,2.0001 L1.9997,0.0001",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997,2.0001 L15.9997,0.0001",
    id: "Stroke-5"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendarGray);
export default __webpack_public_path__ + "static/media/ico_calendar_gray.257150baa4cd2f1d9fb8ac00186f9493.svg";
export { ForwardRef as ReactComponent };